exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.AttendancesAnalysisPanel{padding:20px;border-radius:5px;box-shadow:1px 1px 5px #a3a3a3}strong{color:#fff!important}div.tooltip-wrap{z-index:1}form.chart-filter{margin-bottom:15px}form.chart-filter>:not(:first-child){margin-left:5px}button.btn-chart-filter,form.chart-filter>input{padding:6px}div.analitics-chart-main{padding:5px}div.analitics-chart-main::-webkit-scrollbar{display:none}@media (max-width:475px){form.chart-filter{display:flex;flex-direction:column}form.chart-filter>:not(:first-child){margin-left:0;margin-top:8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/assets/js/pages/Site/AttendancesAnalysisPanel/styles.css
// module id = ktUd
// module chunks = 1